"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Button_default
} from "./chunk-WBZIOSC6.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/SimpleCard/SimpleCard.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SimpleCard = forwardRef(
  function SimpleCard2({
    referId,
    tag,
    title,
    description,
    reverse,
    iconDescriptions,
    image,
    buttons,
    backgroundColor,
    videoUrl,
    gif
  }) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        id: referId,
        className: `flex flex-col ${reverse ? "md:flex-row-reverse" : "md:flex-row"} justify-center items-center px-24 xl:px-0 w-full gap-16 md:gap-24 lg:gap-40 lg:p-56 py-40 lg:py-80 ${backgroundColor}`,
        children: [
          tag && /* @__PURE__ */ jsx(
            "p",
            {
              className: "md:hidden w-full max-w-[455px] md:max-w-[510px] font-bold text-stone-700 uppercase text-sm leading-3",
              dangerouslySetInnerHTML: {
                __html: tag
              }
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "flex overflow-hidden justify-center items-center my-16 md:my-0 w-full md:w-auto lg:min-w-[455px] max-w-[455px] rounded-md md:rounded-2xl", children: [
            image && /* @__PURE__ */ jsx(
              Image_default,
              {
                src: image.path,
                alt: image.alternativeText,
                width: 455,
                height: 455,
                className: "object-cover w-full h-full"
              }
            ),
            gif && /* @__PURE__ */ jsxs("picture", { children: [
              /* @__PURE__ */ jsx("source", { srcSet: `${gif}.webp`, type: "image/webp" }),
              /* @__PURE__ */ jsx("source", { srcSet: `${gif}.gif`, type: "image/gif" }),
              /* @__PURE__ */ jsx(
                "img",
                {
                  src: `${gif}.gif`,
                  alt: "Anima\xE7\xE3o",
                  width: 455,
                  height: 455,
                  className: "object-cover w-full max-w-[455px] h-auto rounded-md md:rounded-2xl"
                }
              )
            ] }),
            videoUrl && !image && /* @__PURE__ */ jsxs("video", { width: "100%", height: "100%", muted: true, playsInline: true, loop: true, autoPlay: true, children: [
              /* @__PURE__ */ jsx("source", { src: videoUrl, type: "video/webm" }),
              /* @__PURE__ */ jsx("source", { src: videoUrl, type: "video/mp4" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: " gap-16 w-full max-w-[455px] md:max-w-[510px]", children: [
            tag && /* @__PURE__ */ jsx(
              "p",
              {
                className: "hidden md:block font-bold text-stone-700 uppercase text-sm leading-1",
                dangerouslySetInnerHTML: {
                  __html: tag
                }
              }
            ),
            /* @__PURE__ */ jsx(
              "h2",
              {
                className: "font-display text-3xl lg:text-4xl font-bold leading-7 lg:leading-8",
                dangerouslySetInnerHTML: {
                  __html: title
                }
              }
            ),
            description && /* @__PURE__ */ jsx(
              "p",
              {
                className: "mt-8 md:w-[429px] lg:w-[510px] text-base leading-4 md:text-lg md:leading-[26px] font-sans",
                dangerouslySetInnerHTML: {
                  __html: description
                }
              }
            ),
            iconDescriptions && /* @__PURE__ */ jsx("div", { className: "flex flex-col", children: iconDescriptions == null ? void 0 : iconDescriptions.map(({ iconName, description: description2 }, index) => /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-16 mt-16", children: /* @__PURE__ */ jsxs("div", { className: "flex", children: [
              /* @__PURE__ */ jsx(
                Icon_default,
                {
                  name: iconName,
                  className: "mt-4 mr-16 w-24 min-w-[24px] h-24 min-h-[24px] text-stone-500 fill-current"
                }
              ),
              /* @__PURE__ */ jsx(
                "p",
                {
                  className: "text-lg font-sans",
                  dangerouslySetInnerHTML: {
                    __html: description2
                  }
                }
              )
            ] }) }, index)) }),
            buttons && buttons.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-col md:flex-row gap-16 mt-16 md:mt-24 w-full", children: buttons == null ? void 0 : buttons.map((props, index) => /* @__PURE__ */ jsx(
              Button_default,
              {
                ...props,
                className: "w-full md:w-max"
              },
              `${props.children}-${index}`
            )) })
          ] })
        ]
      }
    );
  }
);
var SimpleCard_default = SimpleCard;

export {
  SimpleCard_default
};
